
/* accordion items */
console.log("FEATURE ACCORDION SCRIPT LOADED");


(function () {
  if (window.__featuresAccordionInit) return;
  window.__featuresAccordionInit = true;

  document.addEventListener("click", function (e) {

    /* FEATURES (H2) accordion */
    const groupHeader = e.target.closest(".feature-group-header");
    if (groupHeader) {
      e.preventDefault();
      e.stopPropagation();

      const group = groupHeader.closest(".feature-group");
      if (!group) return;

      group.classList.toggle("is-open");
      console.log("Toggled feature group");
      return;
    }

    /* FEATURE ITEM accordion */
    const itemHeader = e.target.closest(".feature-header");
    if (itemHeader) {
      e.preventDefault();
      e.stopPropagation();

      const item = itemHeader.closest(".feature-item");
      if (!item) return;

      item.classList.toggle("is-open");
      console.log("Toggled feature item");
    }

  });
})();

/* size guide */
(function () {
  if (window.__sizeGuideTabsInit) return;
  window.__sizeGuideTabsInit = true;

  document.addEventListener("click", function (e) {
    const tab = e.target.closest(".size-guide-tab");
    if (!tab) return;

    const unit = tab.dataset.unit;
    const container = tab.closest(".pdp-size-guide");
    if (!container) return;

    // Tabs
    container.querySelectorAll(".size-guide-tab").forEach(t =>
      t.classList.toggle("is-active", t === tab)
    );

    // Panels
    container.querySelectorAll(".size-guide-panel").forEach(panel =>
      panel.classList.toggle("is-active", panel.dataset.unit === unit)
    );
  });
})();


/* for JUNIP REVIEWS
* hide all 3 stars, and display only the first 3 items that has 5 stars */
function filterAndLimitJunipReviews() {
  const reviews = document.querySelectorAll(
    '.junip-review-grid-item-container.junip-pb-3'
  );

  let shown = 0;

  reviews.forEach((review) => {
    const rating = review.querySelector('.junip-star-ratings-container');
    const isFiveStar =
      rating && rating.getAttribute('aria-label') === '5 stars';

    if (isFiveStar && shown < 3) {
      review.style.display = ''; // show
      shown++;
    } else {
      review.style.display = 'none'; // hide everything else
    }
  });
}

// Run initially
filterAndLimitJunipReviews();

// Watch for async loading (Junip loads after)
const observer = new MutationObserver(() => {
  filterAndLimitJunipReviews();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

$(document).on('click', '.feature-group-content.reviews-link', function(e) {
  e.preventDefault();

  function scrollToJunip() {
    const $el = $('.junip-container-lg');

    if ($el.length) {
      $('html, body').animate({
        scrollTop: $el.offset().top - 80
      }, 500);
      return true;
    }
    return false;
  }

  // Try immediately
  if (scrollToJunip()) return;

  // Observe DOM changes (better than setInterval)
  const observer = new MutationObserver(function() {
    if (scrollToJunip()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Safety timeout (stop after 5s)
  setTimeout(() => observer.disconnect(), 5000);
});